/**
 * Creates a help prompt for node assistant
 * @param nodeName - The name of the node
 * @returns Formatted prompt string
 */
export function createNodeHelpPrompt(nodeName: string): string {
	return `Help me understand how to use ${nodeName} node`;
}

/**
 * Creates an error prompt for node assistant
 * @param nodeName - The name of the node
 * @param errorCode - The error code
 * @param errorMessage - The error message
 * @returns Formatted prompt string
 */
export function createNodeErrorPrompt(
	nodeName: string,
	errorCode: string,
	errorMessage: string
): string {
	return `I got ${errorCode}: ${errorMessage} while using ${nodeName} node. Please help me fix it`;
}
